import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * A tap on a link should land at the top of the new screen. Client-side navigation leaves the
 * document scrolled where the last screen was, so following "See the full season schedule" from
 * halfway down the home page opens the season halfway down too.
 *
 * Back and forward are left alone: the browser restores the old offset on a POP, and that is
 * the position the player was reading.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}
